import { render, staticRenderFns } from "./BaseLoginPwd.vue?vue&type=template&id=27b998f2&scoped=true"
import script from "./BaseLoginPwd.vue?vue&type=script&lang=js"
export * from "./BaseLoginPwd.vue?vue&type=script&lang=js"
import style0 from "./BaseLoginPwd.vue?vue&type=style&index=0&id=27b998f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b998f2",
  null
  
)

export default component.exports